import React from "react";
import { useTranslation } from "react-i18next";
import { Phone, Globe, ShieldCheck, Unplug, Loader2 } from "lucide-react";

export default function IntegrationCard({ integration, onDisconnect, onTest, testingId }) {
  const { t } = useTranslation();
  const isTesting = testingId === integration.id;
  const name =
    integration.display_name ||
    integration.phone_number ||
    integration.page_name ||
    t("Cuenta vinculada");

  return (
    <div className="flex items-center justify-between gap-3 px-3 py-2 rounded-md border border-border bg-bg hover:border-fg-subtle transition-colors">
      <div className="min-w-0 flex-1">
        <div className="text-sm font-medium text-fg truncate" title={name}>
          {name}
        </div>
        <div className="mt-0.5 flex items-center gap-3 text-[12px] md:text-[11px] text-fg-muted flex-wrap">
          {integration.phone_number && integration.phone_number !== name && (
            <span className="inline-flex items-center gap-1">
              <Phone className="w-3 h-3 text-fg-subtle" aria-hidden="true" />
              {integration.phone_number}
            </span>
          )}
          {integration.page_name && integration.page_name !== name && (
            <span className="inline-flex items-center gap-1">
              <Globe className="w-3 h-3 text-fg-subtle" aria-hidden="true" />
              {integration.page_name}
            </span>
          )}
        </div>
      </div>

      <div className="flex items-center gap-1 shrink-0">
        <button
          type="button"
          onClick={() => onTest(integration.id)}
          disabled={isTesting}
          title={t("Verificar conexión")}
          aria-label={t("Verificar conexión")}
          className="inline-flex w-7 h-7 items-center justify-center rounded-md text-fg-muted hover:bg-bg-muted hover:text-fg disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {isTesting ? (
            <Loader2 className="w-3.5 h-3.5 animate-spin" aria-hidden="true" />
          ) : (
            <ShieldCheck className="w-3.5 h-3.5" aria-hidden="true" />
          )}
        </button>
        <button
          type="button"
          onClick={() => onDisconnect(integration)}
          title={t("Desconectar")}
          aria-label={t("Desconectar integración")}
          className="inline-flex w-7 h-7 items-center justify-center rounded-md text-fg-muted hover:bg-status-error-soft hover:text-status-error transition-colors"
        >
          <Unplug className="w-3.5 h-3.5" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
